"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PartyFindWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _PartyFindWindowModule = _interopRequireDefault(require("./PartyFindWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _inputElements = require("../../../inputElements");

var _PartyFindWindow = _interopRequireDefault(require("./PartyFindWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// TODO: i18n
var classOptions = [{
  value: "archer",
  label: "Archer"
}, {
  value: "cleric",
  label: "Cleric"
}, {
  value: "knight",
  label: "Knight"
}, {
  value: "necromancer",
  label: "Necromancer"
}, {
  value: "paladin",
  label: "Paladin"
}, {
  value: "summoner",
  label: "Summoner"
}, {
  value: "wizard",
  label: "Wizard"
}, {
  value: "warrior",
  label: "Warrior"
}];

function PartyFindWindow(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "waiting" : _ref$type,
      _ref$parties = _ref.parties,
      parties = _ref$parties === void 0 ? [] : _ref$parties,
      _ref$waitings = _ref.waitings,
      waitings = _ref$waitings === void 0 ? [] : _ref$waitings,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(classOptions.find(function (o) {
    return o.value === "warrior";
  })),
      _useState2 = _slicedToArray(_useState, 2),
      selectOption = _useState2[0],
      setSelectOption = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedPartyIndex = _useState4[0],
      setSelectedPartyIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedWaitingIndex = _useState6[0],
      setSelectedWaitingIndex = _useState6[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PartyFindWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _PartyFindWindowModule.default.dragHandler,
    classNameCloseBtn: _PartyFindWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _PartyFindWindowModule.default.tableTitleParties
  }, formatMessage(_PartyFindWindow.default.recruit)), /*#__PURE__*/_react.default.createElement("div", {
    className: _PartyFindWindowModule.default.tableTitleWaitings
  }, formatMessage(_PartyFindWindow.default.waiting)), /*#__PURE__*/_react.default.createElement("div", {
    className: _PartyFindWindowModule.default.tableParties
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_PartyFindWindow.default.name)), /*#__PURE__*/_react.default.createElement("td", null, "#"), /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_PartyFindWindow.default.avgLv)), /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_PartyFindWindow.default.partyLv)), /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_PartyFindWindow.default.class)))), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", null)), parties.map(function (entry, idx) {
    var id = entry.id,
        name = entry.name,
        members = entry.members,
        level = entry.level,
        lookingFor = entry.lookingFor;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: id,
      onClick: function onClick() {
        setSelectedPartyIndex(idx);
      },
      className: (0, _classnames.default)(idx === selectedPartyIndex && _PartyFindWindowModule.default.isSelected)
    }, /*#__PURE__*/_react.default.createElement("td", null, name), /*#__PURE__*/_react.default.createElement("td", null, "".concat(members.length, "/8")), /*#__PURE__*/_react.default.createElement("td", null, members.reduce(function (avg, member, _, _ref2) {
      var length = _ref2.length;
      return avg + member.level / length;
    }, 0)), /*#__PURE__*/_react.default.createElement("td", null, level), /*#__PURE__*/_react.default.createElement("td", null, lookingFor));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: _PartyFindWindowModule.default.tableWaitings
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_PartyFindWindow.default.name)), /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_PartyFindWindow.default.lv)), /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_PartyFindWindow.default.class)))), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", null)), waitings.map(function (entry, idx) {
    var id = entry.id,
        name = entry.name,
        level = entry.level,
        characterClass = entry.characterClass;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: id,
      onClick: function onClick() {
        setSelectedWaitingIndex(idx);
      },
      className: (0, _classnames.default)(idx === selectedWaitingIndex && _PartyFindWindowModule.default.isSelected)
    }, /*#__PURE__*/_react.default.createElement("td", null, name), /*#__PURE__*/_react.default.createElement("td", null, level), /*#__PURE__*/_react.default.createElement("td", null, characterClass.i18nName.en
    /* TODO: i18n */
    ));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PartyFindWindowModule.default.footer, _PartyFindWindowModule.default[type])
  }, type === "waiting" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND,
    className: _PartyFindWindowModule.default.btnWaitingApply
  }, formatMessage(_PartyFindWindow.default.apply)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND_SEL,
    className: _PartyFindWindowModule.default.btnWaitingWhisper
  }, formatMessage(_PartyFindWindow.default.whisper)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND,
    className: _PartyFindWindowModule.default.btnWaitingRegCancel
  }, formatMessage(_PartyFindWindow.default.regCancel)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND,
    className: _PartyFindWindowModule.default.btnWaitingRefresh
  }, formatMessage(_PartyFindWindow.default.refresh))), type === "member" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND,
    className: _PartyFindWindowModule.default.btnMemberRefresh
  }, formatMessage(_PartyFindWindow.default.refresh))), type === "chief" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _PartyFindWindowModule.default.selectChiefClass
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Select, {
    options: classOptions,
    width: "92px",
    height: "22px",
    defaultValue: selectOption,
    onChange: function onChange(entry) {
      return setSelectOption(classOptions.find(function (o) {
        return (o === null || o === void 0 ? void 0 : o.value) === (entry === null || entry === void 0 ? void 0 : entry.value);
      }));
    }
  })), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND_SEL,
    className: _PartyFindWindowModule.default.btnChiefRegister
  }, formatMessage(_PartyFindWindow.default.reg)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND_SEL,
    className: _PartyFindWindowModule.default.btnChiefCancel
  }, formatMessage(_PartyFindWindow.default.cancel)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND_SEL,
    className: _PartyFindWindowModule.default.btnChiefWhisper
  }, formatMessage(_PartyFindWindow.default.whisper)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND,
    className: _PartyFindWindowModule.default.btnChiefInvite
  }, formatMessage(_PartyFindWindow.default.invite)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.PARTY_FIND,
    className: _PartyFindWindowModule.default.btnChiefRefresh
  }, formatMessage(_PartyFindWindow.default.refresh)))));
}